import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"label":_vm.$t('Separator'),"outlined":"","hide-details":"auto","items":_vm.separatorOptions},model:{value:(_vm.separator),callback:function ($$v) {_vm.separator=$$v},expression:"separator"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }